import VideoHero from './VideoHero'

export default VideoHero
